import React, { useEffect, useState } from "react";
import ReservationList from "../components";
import { useQuery, useMutation } from "@tanstack/react-query";
import { useNotification } from "../../../../context/NotificationProvider";
import { useLocalization } from "../../../../context/LocalizeContextProvider";
import {
  getReservations,
  getDetailReservation,
  updateReservation,
  postBookingReservation,
  postNewPatientReservation,
  postStartVisitReservation,
  endVisitReservation,
  postEndToStartVisitReservation,
  postTransferPatient,
} from "../../../../services/Handlers/ReservationService";
import {
  postUseActivePackage,
  deleteActivePackage,
  postUndoActivePackage,
} from "../../../../services/Handlers/PackageService";
import {
  postUseActiveDeposit,
  postUndoActiveDeposit,
} from "../../../../services/Handlers/DepositService";
import { postRefoundUsedBalance } from "../../../../services/Handlers/SaldoService";
import { useAuth } from "../../../../context/AuthProvider";
import { useHome } from "../../../../context/HomeProvider";
import moment from "moment";
import {
  parsePatientDob,
  formatPatientDobForApi,
} from "../../../../utils/patientDob";
import {
  getTimeSlotOneHourReservationFormat,
  getFilteredTime,
  formatTimeSlots,
  retrieveUrlFile,
} from "../../../../utils/utils";
import { roleUser, statusReservation } from "../../../../utils/constants";
import { useModal } from "../../../../context/ModalProvider";
import { postSavePayment } from "../../../../services/Handlers/PaymentService";

export const defaultDetailReservation = {
  id: null,
  user_id: null,
  service_id: null,
  patientId: null,
  doctorId: null,
  noRm: null,
  allergies: null,
  reservationDate: null,
  reservationTime: null,
  durationVisit: null,
  doctorName: "",
  status: "",
  noSequence: null,
  identityNumber: null,
  identityType: null,
  name: "",
  email: "",
  phoneNumber: null,
  dateOfBirth: null,
  gender: null,
  address: null,
  payment: null,
  payment_parent: null,
  is_patient_new: false,
  actived_reservations: [],
  wallet_balance: 0,
};

export default function Reservation() {
  const deafultDataReservationNew = {
    durationVisit: null,
    availableSlot: [],
    reservationDate: null,
    doctorId: null,
    doctorName: null,
  };
  const defaultDataFormPatientNew = {
    identificationType: "KTP",
    medicalRecordNumber: null,
    serviceId: null,
    locationId: null,
    timeVisit: [],
    identificationNumber: "",
    name: "",
    email: "",
    gender: null,
    dateOfBirth: null,
    phoneNumber: null,
    allergies: [],
    remark: "",
    address: "",
  };
  const defaultDataTransferPatient = {
    durationVisit: null,
    availableSlot: [],
    timeVisit: [],
    reservationDate: null,
    doctorId: null,
    doctorName: null,
    parentOrderId: null,
    locationId: null,
    patientId: null,
  };
  const notification = useNotification();
  const localize = useLocalization();
  const modal = useModal();
  const { userDetail, role } = useAuth();
  const { dataDoctors, dataServices, refetchDoctors } = useHome();
  const [reservationDate, setReservationDate] = useState(moment());
  const [dataReservation, setDataReservation] = useState([]);
  const [dataDetailReservation, setDataDetailReservation] = useState(
    defaultDetailReservation
  );
  const [dataReservationNew, setDataReservationNew] = useState(
    deafultDataReservationNew
  );
  const [dataFormPatientNew, setDataFormPatientNew] = useState(
    defaultDataFormPatientNew
  );
  const [dataTransferPatient, setDataTransferPatient] = useState(
    defaultDataTransferPatient
  );
  const [dataUsePackage, setDataUsePackage] = useState([]);
  const [dataUseDeposit, setDataUseDeposit] = useState([]);

  const [selectedExistingPatient, setSelectedExistingPatient] = useState(null);
  const [showModalDetail, setShowModalDetail] = useState(null);
  const [showModalStartVisit, setShowModalStartVisit] = useState(null);
  const [showModalEndVisit, setShowModalEndVisit] = useState(null);
  const [showModalAlert, setShowModalAlert] = useState(null);
  const [showModalTransfer, setShowModalTransfer] = useState(null);

  const isDoctorId =
    ((role === roleUser.ROLE_DOCTOR || role === roleUser.ROLE_BEAUTICIAN) &&
      userDetail?.id) ||
    null;

  const { isLoading: isLoadingEndToStart, mutate: mutateSubmitEndtoStart } =
    useMutation(postEndToStartVisitReservation, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          refetch();
          notification.success(localize.getText("successStartVisit"));
          handleClearAllFormModal(null);
          setDataUsePackage([]);
          setDataUseDeposit([]);
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    });

  const {
    isLoading: isLoadingSubmitExisting,
    mutate: mutateSubmitReservation,
  } = useMutation(postBookingReservation, {
    onSuccess: (res) => {
      if (res.status === 200 || res.status === 201) {
        refetch();
        notification.success(localize.getText("successAddReservation"));
        handleHideShowModalAdd(null);
      } else {
        notification.error(
          res?.data?.detail || localize.getText("unknownMessageError")
        );
      }
    },
    onError: () => {
      notification.error(localize.getText("unknownMessageError"));
    },
  });

  const { isLoading: isLoadingSubmitPayment, mutate: mutateSubmitPayment } =
    useMutation(postSavePayment, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          notification.success(localize.getText("successAddPayment"));
          refetchDetail();
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    });

  const { isLoading: isLoadingUsePackage, mutate: mutateUsePackage } =
    useMutation(postUseActivePackage, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          refetchDetail();
          notification.success(localize.getText("successUsePackage"));
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    });

  const { isLoading: isLoadingUseDeposit, mutate: mutateUseDeposit } =
    useMutation(postUseActiveDeposit, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          refetchDetail();
          notification.success(localize.getText("successUseDeposit"));
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    });

  const { isLoading: isLoadingRefoundSaldo, mutate: mutateRefoundSaldo } =
    useMutation(postRefoundUsedBalance, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          refetchDetail();
          notification.success(localize.getText("successRefoundSaldo"));
          modal.dismiss();
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
          modal.dismiss();
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
        modal.dismiss();
      },
    });

  const { isLoading: isLoadingDeletePackage, mutate: mutateDeletePackage } =
    useMutation(deleteActivePackage, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          refetchDetail();
          notification.success(localize.getText("successDeletePackage"));
          modal.dismiss();
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    });

  const { isLoading: isLoadingUndoPackage, mutate: mutateUndoPackage } =
    useMutation(postUndoActivePackage, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          refetchDetail();
          notification.success(localize.getText("successUpdatePackage"));
          modal.dismiss();
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    });

  const { isLoading: isLoadingUndoDeposit, mutate: mutateUndoDeposit } =
    useMutation(postUndoActiveDeposit, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          refetchDetail();
          notification.success(localize.getText("successUpdateDeposit"));
          modal.dismiss();
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    });

  const { isLoading: isLoadingSubmitNew, mutate: mutateSubmitReservationNew } =
    useMutation(postNewPatientReservation, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          refetch();
          notification.success(localize.getText("successAddReservation"));
          handleClearAllFormModal();
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    });

  const { isLoading: isLoadingTransfer, mutate: mutateTransferPatient } =
    useMutation(postTransferPatient, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          refetch();
          notification.success(localize.getText("successTransferPatient"));
          handleClearAllFormModal();
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    });

  const {
    isLoading: isLoadingDetail,
    isFetching: isFetchingDetail,
    refetch: refetchDetail,
  } = useQuery(
    ["DetailReservation", showModalDetail],
    () => getDetailReservation(showModalDetail),
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          const response = res.data;
          if (response) {
            const status = statusReservation.find(
              (item) => item.value === response.status
            );
            const reservationTimeFormat = getFilteredTime(
              response.duration_visit,
              response.time_slots
            )[0];
            const reservationTime =
              moment(
                reservationTimeFormat.availability_start,
                "HH:mm:ss"
              ).format("HH:mm") +
              " - " +
              moment(reservationTimeFormat.availability_end, "HH:mm:ss").format(
                "HH:mm"
              );

            setDataDetailReservation((prevState) => ({
              ...prevState,
              id: response.id,
              patientId: response.patient_id,
              reservationDate: moment(
                response.reservation_date,
                "YYYY-MM-DD"
              ).format("dddd DD MMMM YYYY"),
              reservationTime,
              durationVisit: response.duration_visit,
              doctorName: response.doctorName ||
                dataDoctors.find((value) => value.id === response.doctor_id)
                  ?.name || "",
              doctorId: response.doctor_id,
              status,
              noSequence: response.no_sequence,
              // Use patient data (more accurate than user table)
              identityNumber: response.patient?.identification_number || response.user_identity_number,
              identityType: response.patient?.identification_type || response.user_identity_type,
              name: response.patient?.name || response.user_name,
              email: response.patient?.email || response.user_email,
              phoneNumber: response.patient?.phone_number || response.user_phone_number,
              dateOfBirth: moment(
                response.patient?.dob || response.user_date_of_birth,
                "YYYY-MM-DD"
              ).format("DD MMMM YYYY"),
              gender: response.patient?.gender || response.user_gender,
              address: response.patient?.address || null,
              allergies: response.patient?.allergy || null,
              noRm: response.patient?.medical_record_number || null,
              activeVisitId: response.patient?.activeVisitId || null,
              visitCompleted: response.patient?.visitCompleted || null,
              payment: response.payment,
              payment_parent: response.payment_parent,
              user_id: response.user_id,
              service_id: response?.service_id,
              is_patient_new: response?.is_patient_new || false,
              actived_reservations: response?.actived_reservations || [],
              actived_packages: response?.actived_packages || [],
              actived_deposits: response?.actived_deposits || [],
              wallet_balance: response?.wallet_balance || 0,
            }));
            setDataFormPatientNew((prevState) => ({
              ...prevState,
              // Use patient data (more accurate than user table)
              identificationType: response.patient?.identification_type || response.user_identity_type,
              identificationNumber: response.patient?.identification_number || response.user_identity_number,
              name: response.patient?.name || response.user_name,
              phoneNumber: response.patient?.phone_number || response.user_phone_number,
              email: response.patient?.email || response.user_email,
              dateOfBirth: response.patient?.dob || response.user_date_of_birth,
              gender: response.patient?.gender || response.user_gender,
              locationId: response.location_id,
            }));
          }
        } else {
          notification.error(localize.getText("unknownMessageError"));
        }
      },
      enabled: !!showModalDetail,
    }
  );

  const { isFetching: isFetchList, refetch } = useQuery(
    ["ReservationList", reservationDate, isDoctorId],
    () =>
      getReservations(
        userDetail.businessId,
        reservationDate.format("YYYY-MM-DD"),
        isDoctorId
      ),
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          const response = res.data;
          if (response) {
            if (response.length > 0) {
              const reservation = response.map((item) => {
                return {
                  doctorId: item.doctorId,
                  doctorName: item.doctorName || "",
                  durationVisit: item.durationVisit,
                  reservations: getTimeSlotOneHourReservationFormat(
                    item.doctorSchedule || [],
                    item.reservations || []
                  ),
                };
              });
              setDataReservation(reservation);
            }
          }
        } else {
          notification.error(localize.getText("unknownMessageError"));
        }
      },
      enabled: !!(userDetail?.businessId && dataDoctors.length > 0),
    }
  );

  const { isLoading: isLoadingUpdate, mutate: mutateUpdateReservation } =
    useMutation(updateReservation, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          refetch();
          setDataDetailReservation(defaultDetailReservation);
          handleClearAllFormModal();
        } else {
          notification.error(localize.getText("unknownMessageError"));
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    });

  const { isLoading: isLoadingStartVisit, mutate: mutateStartVisit } =
    useMutation(postStartVisitReservation, {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          notification.success(localize.getText("successStartVisit"));
          setDataUsePackage([]);
          setDataUseDeposit([]);
          handleClearAllFormModal();
          refetch();
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    });

  const { isLoading: isLoadingEndVisit, mutate: mutateEndVisit } = useMutation(
    endVisitReservation,
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          notification.success(localize.getText("endVisitSuccess"));
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
        handleClearAllFormModal();
        refetch();
      },
      onError: () => {
        notification.error(localize.getText("unknownMessageError"));
      },
    }
  );

  useEffect(() => {
    if (userDetail) {
      refetchDoctors();
    }
    //eslint-disable-next-line
  }, [userDetail]);

  const createReservation = (patientData) => ({
    doctorId: dataReservationNew.doctorId,
    dateVisit: dataReservationNew.reservationDate.format("YYYY-MM-DD"),
    timeVisit: dataFormPatientNew.timeVisit,
    businessId: userDetail.businessId,
    serviceId: dataFormPatientNew.serviceId.value,
    email: null,
    name: patientData.name,
    userDob: moment(patientData.dob, patientData.dobFormat).format(
      "YYYY-MM-DD"
    ),
    userPhoneNumber: patientData.phoneNumber,
    gender: patientData.gender,
    identificationNumber: patientData.identificationNumber,
    identificationType: patientData.identificationType,
    durationVisit: dataReservationNew.durationVisit,
    patientId: patientData.patientId,
    status: "ACTIVE",
  });

  const handleHideShowModalDetial = (value) => {
    if (!value) {
      setDataDetailReservation(defaultDetailReservation);
      handleResetFormPatientNew();
    }
    setShowModalDetail(value);
  };

  const handleHideShowModalAdd = (data) => {
    if (!data) {
      setDataReservationNew(deafultDataReservationNew);
      handleResetFormPatientNew();
      return;
    }
    const availableSlot = formatTimeSlots(data.availableSchedule);
    if (getFilteredTime(data.durationVisit, availableSlot).length === 1) {
      handleChangeForm("timeVisit", availableSlot);
    }
    if (dataServices.length === 1) {
      handleChangeForm("serviceId", {
        label: dataServices[0].name,
        value: dataServices[0].id,
      });
    }
    setDataReservationNew({
      doctorId: data.doctorId,
      doctorName: data.doctorName,
      availableSlot,
      durationVisit: data.durationVisit,
      reservationDate: reservationDate,
    });
  };

  const handleChangeStatusReservation = (data) => {
    mutateUpdateReservation({
      booking_id: data.booking_id,
      status: data.status,
    });
  };

  const handleChangePatientReservation = () => {
    if (!selectedExistingPatient.identificationNumber) {
      notification.error(
        `Pasien ${selectedExistingPatient.name} tidak mempunyai KTP/Paspor`
      );
      return;
    }

    mutateUpdateReservation({
      booking_id: dataDetailReservation.id,
      patient_id: selectedExistingPatient.id,
      location_id: dataFormPatientNew.locationId,
    });
  };

  const handleChangeForm = (name, value) => {
    setDataFormPatientNew((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleChangeTransferPatient = (name, value) => {
    if (name === "doctorId") {
      const selectedSchedule = dataReservation.find(
        (item) => item.doctorId === value?.value
      );
      if (selectedSchedule) {
        const availableSchedule = [];

        selectedSchedule?.reservations?.forEach((item) => {
          availableSchedule.push(...(item?.availableSchedule || []));
        });

        if (availableSchedule.length > 0) {
          const availableSlot = formatTimeSlots(availableSchedule);
          handleChangeTransferPatient("availableSlot", availableSlot);
        }
        handleChangeTransferPatient(
          "durationVisit",
          selectedSchedule?.durationVisit
        );
        handleChangeTransferPatient("timeVisit", []);
      }
    }
    setDataTransferPatient((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleResetFormPatientNew = () => {
    setDataFormPatientNew(defaultDataFormPatientNew);
    setSelectedExistingPatient(null);
  };

  const handleSubmitNew = () => {
    const data = {
      ...dataFormPatientNew,
      locationId:
        dataFormPatientNew.locationId?.value || dataFormPatientNew.locationId,
      identificationNumber: dataFormPatientNew.identificationNumber,
      userPhoneNumber: dataFormPatientNew.phoneNumber,
      doctorId: dataReservationNew.doctorId,
      dateVisit: dataReservationNew.reservationDate.format("YYYY-MM-DD"),
      businessId: userDetail.businessId,
      serviceId: dataFormPatientNew.serviceId.value,
      userDob: dataFormPatientNew.dateOfBirth,
      durationVisit: dataReservationNew.durationVisit,
    };

    mutateSubmitReservationNew(data);
  };

  const handleUpdatePatientReservation = () => {
    const data = {
      ...dataFormPatientNew,
      locationId:
        dataFormPatientNew.locationId?.value || dataFormPatientNew.locationId,
      booking_id: dataDetailReservation.id,
      isUpdate: true,
    };

    mutateSubmitReservationNew(data);
  };

  const handleSubmitExisting = () => {
    const data = {
      doctorId: dataReservationNew.doctorId,
      dateVisit: dataReservationNew.reservationDate.format("YYYY-MM-DD"),
      timeVisit: dataFormPatientNew.timeVisit,
      durationVisit: dataReservationNew.durationVisit,
      businessId: userDetail.businessId,
      serviceId: dataFormPatientNew.serviceId.value,
      patientId: selectedExistingPatient.id,
      locationId:
        dataFormPatientNew.locationId?.value || dataFormPatientNew.locationId,
      email: null,
      name: selectedExistingPatient.name,
      userDob: formatPatientDobForApi(
        parsePatientDob(selectedExistingPatient.dob).toDate()
      ),
      userPhoneNumber: selectedExistingPatient.phoneNumber,
      gender: selectedExistingPatient.gender,
      identificationNumber: selectedExistingPatient.identificationNumber,
      identificationType: selectedExistingPatient.identificationType,
    };

    if (!selectedExistingPatient.identificationNumber) {
      notification.error(
        `Pasien ${selectedExistingPatient.name} tidak mempunyai KTP/Paspor`
      );
      return;
    }

    if (
      selectedExistingPatient.identificationNumber.length !== 16 &&
      selectedExistingPatient.identificationType === "KTP"
    ) {
      notification.error(`Harap masukkan Nomor KTP 16 angka`);
      return;
    }

    mutateSubmitReservation(data);
  };

  const handleClearAllFormModal = async () => {
    await setDataDetailReservation({ ...defaultDetailReservation });
    setShowModalDetail(null);
    setShowModalStartVisit(null);
    setShowModalEndVisit(null);
    setShowModalAlert(null);
    setShowModalTransfer(null);
    setDataReservationNew(deafultDataReservationNew);
    setDataTransferPatient(defaultDataTransferPatient);
    handleResetFormPatientNew();
    modal.dismiss();
  };

  const handleModalStartVisit = (data) => {
    if (!data) {
      setShowModalStartVisit(null);
      return;
    }
    setShowModalStartVisit({
      bookingId: data.bookingId,
      patientId: data.patientId,
      doctorId: data.doctorId,
      identificationNumber: data.identificationNumber,
      isPatientNew: data.isPatientNew,
    });
  };

  const handleModalEndVisit = (data) => {
    if (!data) {
      setShowModalEndVisit(null);
      return;
    }

    setShowModalEndVisit({
      patientId: data.patientId,
      bookingId: data.bookingId,
      visitCompleted: data.visitCompleted,
    });
  };

  const handleStartVisit = (data) => {
    const alergiesDTOs = dataFormPatientNew.allergies.map((item) => ({
      ...item,
      ...(item.__isNew__ ? {} : { __isNew__: false }),
    }));

    const patientData = !data.bookingId
      ? selectedExistingPatient?.id
        ? {
            name: selectedExistingPatient.name,
            dob: formatPatientDobForApi(
              parsePatientDob(selectedExistingPatient.dob).toDate()
            ),
            dobFormat: "YYYY-MM-DD",
            phoneNumber: selectedExistingPatient.phoneNumber,
            gender: selectedExistingPatient.gender,
            identificationNumber: selectedExistingPatient.identificationNumber,
            identificationType: selectedExistingPatient.identificationType,
            patientId: selectedExistingPatient.id,
          }
        : {
            name: dataFormPatientNew.name,
            dob: dataFormPatientNew.dateOfBirth,
            dobFormat: "YYYY-MM-DD", // Explicit format for new patient
            phoneNumber: dataFormPatientNew.phoneNumber,
            gender: dataFormPatientNew.gender,
            identificationNumber: dataFormPatientNew.identificationNumber,
            identificationType: dataFormPatientNew.identificationType,
            patientId: null,
          }
      : null;

    const patientDTO = data?.isPatientNew
      ? {
          ...dataFormPatientNew,
          alergy: alergiesDTOs,
          dob: formatPatientDobForApi(dataFormPatientNew.dateOfBirth),
          dateOfBirth: formatPatientDobForApi(dataFormPatientNew.dateOfBirth),
        }
      : null;

    const dataPatientForm = {
      ...data,
      ...(patientData && { reservation: createReservation(patientData) }),
      ...(patientDTO && { patientDTO }),
      locationId:
        dataFormPatientNew.locationId?.value || dataFormPatientNew.locationId,
      packages: dataUsePackage,
      deposits: dataUseDeposit,
      businessId: userDetail.businessId,
      createdBy: userDetail?.firstName,
      updatedBy: userDetail?.firstName,
      createdById: userDetail?.id,
    };

    mutateStartVisit(dataPatientForm);
  };

  const handleEndVisit = async (data) => {
    let imageUrl = "";
    if (data.fileUrl) {
      imageUrl = await retrieveUrlFile(data.fileUrl);
    }

    mutateEndVisit({
      note: data?.note,
      fileUrl: imageUrl,
      status: "DONE",
      patient_id: data.patientId,
      booking_id: showModalEndVisit?.bookingId,
    });
  };

  const handleClickPayment = (value) => {
    const data = {
      bookingId: dataDetailReservation.id,
      userId: dataDetailReservation.user_id,
      patientId: dataDetailReservation?.patientId,
      businessId: userDetail.businessId,
      createdBy: userDetail?.firstName,
      updatedBy: userDetail?.firstName,
      createdById: userDetail?.id,
      ...value,
    };

    mutateSubmitPayment(data);
  };

  const handleShowModalAlert = (value) => {
    setShowModalAlert(value);
  };

  const handleShowModalTransfer = (value) => {
    handleChangeTransferPatient("reservationDate", reservationDate);
    if (!value) {
      setDataTransferPatient(defaultDataTransferPatient);
    }
    setShowModalTransfer(value);
  };

  const handleSubmitTransfer = () => {
    const data = {
      doctorId: dataTransferPatient?.doctorId?.value,
      dateVisit: moment(dataTransferPatient?.reservationDate).format(
        "YYYY-MM-DD"
      ),
      timeVisit: dataTransferPatient?.timeVisit,
      durationVisit: dataTransferPatient?.durationVisit,
      businessId: userDetail.businessId,
      locationId: dataTransferPatient?.locationId?.value,
      serviceId: dataDetailReservation?.service_id,
      patientId: dataDetailReservation?.patientId,
      email: dataDetailReservation?.email,
      name: dataDetailReservation?.name,
      userDob:
        dataDetailReservation?.dateOfBirth &&
        moment(dataDetailReservation?.dateOfBirth, "DD MMMM YYYY").format(
          "YYYY-MM-DD"
        ),
      userPhoneNumber: dataDetailReservation?.phoneNumber,
      gender: dataDetailReservation?.gender,
      identificationNumber: dataDetailReservation?.identityNumber,
      identificationType: dataDetailReservation?.identityType,
      parentBookingId:
        dataDetailReservation?.payment_parent?.booking_id || showModalTransfer,
      previousBookingId: showModalTransfer,
    };

    mutateTransferPatient(data);
  };

  const handleDetailModalAlert = () => {
    handleClearAllFormModal();
    setShowModalDetail(showModalAlert?.previousReservation?.id);
  };

  const handleYaModalAlert = () => {
    let reservation;

    if (!showModalAlert?.newReservation?.bookingId) {
      const patientData = {
        name: selectedExistingPatient.name,
        dob: formatPatientDobForApi(
          parsePatientDob(selectedExistingPatient.dob).toDate()
        ),
        dobFormat: "YYYY-MM-DD",
        phoneNumber: selectedExistingPatient.phoneNumber,
        gender: selectedExistingPatient.gender,
        identificationNumber: selectedExistingPatient.identificationNumber,
        identificationType: selectedExistingPatient.identificationType,
        patientId: selectedExistingPatient.id,
      };
      reservation = createReservation(patientData);
    }

    const data = {
      previousReservation: showModalAlert.previousReservation,
      newReservation: {
        packages: dataUsePackage,
        deposits: dataUseDeposit,
        businessId: userDetail.businessId,
        ...showModalAlert.newReservation,
        ...(reservation && { reservation }),
      },
    };

    mutateSubmitEndtoStart(data);
  };

  const handleUsePackage = (id) => {
    const isReservation = dataDetailReservation.status.label === "Reservasi";

    if (isReservation) {
      const dataUsePackageCopy = [...dataUsePackage];
      const index = dataUsePackageCopy.findIndex((item) => item === id);

      if (index !== -1) {
        dataUsePackageCopy.splice(index, 1);
      } else {
        dataUsePackageCopy.push(id);
      }

      setDataUsePackage(dataUsePackageCopy);
    } else {
      const dataPackage = {
        patientId: dataDetailReservation.patientId,
        bookingId: dataDetailReservation.id,
        packageId: id,
        paymentId: dataDetailReservation?.payment?.id || null,
        businessId: userDetail.businessId,
        createdBy: userDetail?.firstName,
        updatedBy: userDetail?.firstName,
        createdById: userDetail?.id,
      };

      mutateUsePackage(dataPackage);
    }
  };

  const handleUseDeposit = (id) => {
    const isReservation = dataDetailReservation.status.label === "Reservasi";

    if (isReservation) {
      const dataUseDepositCopy = [...dataUseDeposit];
      const index = dataUseDepositCopy.findIndex((item) => item === id);

      if (index !== -1) {
        dataUseDepositCopy.splice(index, 1);
      } else {
        dataUseDepositCopy.push(id);
      }

      setDataUseDeposit(dataUseDepositCopy);
    } else {
      const dataDeposit = {
        patientId: dataDetailReservation.patientId,
        bookingId: dataDetailReservation.id,
        depositId: id,
        paymentId: dataDetailReservation?.payment?.id || null,
        businessId: userDetail.businessId,
        createdBy: userDetail?.firstName,
        updatedBy: userDetail?.firstName,
        createdById: userDetail?.id,
      };

      mutateUseDeposit(dataDeposit);
    }
  };

  const handleUndoUsedPackage = (id) => {
    const data = {
      patientId: dataDetailReservation.patientId,
      packageId: id,
      paymentId: dataDetailReservation?.payment?.id,
    };

    mutateUndoPackage(data);
  };

  const handleUndoUsedDeposit = (id) => {
    const data = {
      patientId: dataDetailReservation.patientId,
      depositId: id,
      paymentId: dataDetailReservation?.payment?.id,
    };

    mutateUndoDeposit(data);
  };

  const handleRefoundSaldo = () => {
    const data = {
      patientId: dataDetailReservation.patientId,
      paymentId: dataDetailReservation?.payment?.id,
      updatedBy: userDetail?.firstName,
    };

    mutateRefoundSaldo(data);
  };

  const handleDeletePackage = (id) => {
    mutateDeletePackage(id);
  };
  return (
    <ReservationList
      loading={isFetchList || isLoadingUpdate || isLoadingTransfer}
      isLoadingDetail={
        isLoadingDetail ||
        isFetchingDetail ||
        isLoadingSubmitNew ||
        isLoadingUpdate ||
        isLoadingSubmitPayment ||
        isLoadingStartVisit ||
        isLoadingDeletePackage ||
        isLoadingUsePackage ||
        isLoadingUndoPackage ||
        isLoadingUseDeposit ||
        isLoadingUndoDeposit ||
        isLoadingRefoundSaldo
      }
      isLoadingAdd={
        isLoadingSubmitExisting || isLoadingSubmitNew || isLoadingStartVisit
      }
      isLoadingTransfer={isLoadingTransfer}
      isLoadingStartVisit={isLoadingStartVisit}
      isLoadingEndVisit={isLoadingEndVisit}
      dataReservation={dataReservation}
      reservationDate={reservationDate}
      setReservationDate={setReservationDate}
      showModalDetail={showModalDetail}
      businessId={userDetail?.businessId}
      setShowModalAdd={handleHideShowModalAdd}
      setShowModalDetail={handleHideShowModalDetial}
      dataDetailReservation={dataDetailReservation}
      handleChangeStatusReservation={handleChangeStatusReservation}
      dataReservationNew={dataReservationNew}
      dataFormPatientNew={dataFormPatientNew}
      handleChangeForm={handleChangeForm}
      handleSubmitNew={handleSubmitNew}
      handleSubmitExisting={handleSubmitExisting}
      dataServices={dataServices}
      selectedExistingPatient={selectedExistingPatient}
      showModalStartVisit={showModalStartVisit}
      showModalEndVisit={showModalEndVisit}
      setSelectedExistingPatient={setSelectedExistingPatient}
      handleChangePatientReservation={handleChangePatientReservation}
      handleUpdatePatientReservation={handleUpdatePatientReservation}
      handleModalStartVisit={handleModalStartVisit}
      handleModalEndVisit={handleModalEndVisit}
      handleStartVisit={handleStartVisit}
      handleEndVisit={handleEndVisit}
      handleClickPayment={handleClickPayment}
      showModalAlert={showModalAlert}
      handleShowModalAlert={handleShowModalAlert}
      handleDetailModalAlert={handleDetailModalAlert}
      handleYaModalAlert={handleYaModalAlert}
      isLoadingEndToStart={isLoadingEndToStart}
      handleShowModalTransfer={handleShowModalTransfer}
      showModalTransfer={showModalTransfer}
      dataTransferPatient={dataTransferPatient}
      dataUsePackage={dataUsePackage}
      dataUseDeposit={dataUseDeposit}
      handleChangeTransferPatient={handleChangeTransferPatient}
      handleSubmitTransfer={handleSubmitTransfer}
      handleUsePackage={handleUsePackage}
      handleUseDeposit={handleUseDeposit}
      handleDeletePackage={handleDeletePackage}
      handleUndoUsedPackage={handleUndoUsedPackage}
      handleUndoUsedDeposit={handleUndoUsedDeposit}
      handleRefoundSaldo={handleRefoundSaldo}
    />
  );
}
